// extracted by mini-css-extract-plugin
export default {"colHighlighted":"upiTxnAnalysis_colHighlighted__1VFDC","tdTextStyle":"upiTxnAnalysis_tdTextStyle__+uWec","darkTableRowText":"upiTxnAnalysis_darkTableRowText__fmGxT"};